import { useCallback } from 'react';

import { OtpChannel } from '@ocx/graphql';
import { useConfiguration } from '@ocx/data-configuration';

import { useSelectOTPChannelActionSheet } from '../select-otp-channel-action-sheet';

export const useSelectOTPChannelWithModal = () => {
  const { open: openSelectOTPChannelActionSheet } = useSelectOTPChannelActionSheet();
  const {
    otp: { channels: otpChannels },
  } = useConfiguration('auth');

  const select = useCallback(async (): Promise<OtpChannel | null> => {
    if (otpChannels.length === 1) {
      return otpChannels[0];
    }
    const otpChannel = await new Promise<OtpChannel | null>((resolve) => {
      openSelectOTPChannelActionSheet({
        channels: otpChannels,
        onSelected: resolve,
        onCancel: () => resolve(null),
      });
    });
    return otpChannel;
  }, [openSelectOTPChannelActionSheet, otpChannels]);

  return { select };
};
